import type { ScaleResponseType, SimulationResponseType, VariationType } from '~/extensions/simulator/simulator.type'
import { mapResponseData } from '~/utils/dataMapper/simulation.mapper'
import type { MySelfFormData } from './useFormMyself'

export async function callScaleApi(projectType: string): Promise<ScaleResponseType[]> {
  const url = new URL('/meiaapi/scales', import.meta.env.PUBLIC_ENV__APIGEE_URL)
  url.searchParams.append('scaleMode', 'CALCULATED')
  url.searchParams.append('projectType', projectType)

  return fetch(url.toString(), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      client_id: import.meta.env.PUBLIC_ENV__APIGEE_CLIENT_ID,
    },
  }).then((response) => response.json())
}

export const sendMyselfMail = async (form: MySelfFormData, altchaPayload: string) => {
  const url = new URL('/meiaapi/prospect/myself/completion-form', import.meta.env.PUBLIC_ENV__APIGEE_URL)
  return fetch(url.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      client_id: import.meta.env.PUBLIC_ENV__APIGEE_CLIENT_ID,
    },
    body: JSON.stringify({
      adherentName: import.meta.env.PUBLIC_ENV__WEBSITE,
      savingsAmount: form.wrapper.savings,
      loanAmount: form.wrapper.amount,
      clientTitle: form.wrapper.civility,
      clientName: form.wrapper.lastname,
      clientBirthname: form.wrapper.birthname,
      clientFirstname: form.wrapper.firstname,
      clientEmail: form.wrapper.mail,
      clientTel: form.wrapper.phone,
      clientBirthdate: form.wrapper.birthday,
      clientBirthCity: form.wrapper.birthCity,
      clientBirthCounty: form.wrapper.birthCounty,
      clientBirthCountry: form.wrapper.birthCountry,
      employerName: form.wrapper.companyName,
      canvassingConsent: form.wrapper.consent,
      altchaPayload: altchaPayload,
    }),
  }).then((response) => response.json())
}

export const callSimulationApi = async (
  purchaseAmount: number,
  numberOfPayments: number,
  projectType: string,
  variations?: VariationType[],
) => {
  const url = new URL('/meiaapi/calculation/loan', import.meta.env.PUBLIC_ENV__APIGEE_URL)

  const isInsurranceEligible = numberOfPayments >= 12 || purchaseAmount >= 3000

  const response = await fetch(url.toString(), {
    method: 'POST',
    body: JSON.stringify({
      insurances: {
        person: [
          {
            role: 'BORROWER',
            insuranceWish: isInsurranceEligible,
          },
          {
            role: 'CO_BORROWER',
            insuranceWish: false,
          },
        ],
      },
      equipment: {
        equipmentType: 'PERSONALPROJECT',
      },
      usage: 'PERSONAL',
      legalNotices: true,
      variations,
      loanRequest: {
        depositAmount: 0,
        purchaseAmount,
        numberOfPayments,
        loanInformation: {
          projectType,
          scaleMode: 'CALCULATED',
        },
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      client_id: import.meta.env.PUBLIC_ENV__APIGEE_CLIENT_ID,
    },
  }).then((response) => response.json())

  return mapResponseData(response) as SimulationResponseType
}
